export const WEBPAGE_FEATURES_QUERY_KEY = 'webpage-features';

export const FEATURE_RELATED_REQUESTS_QUERY_KEY = 'feature-related-requests';
